import { AlphaTBoxIcon } from './AlphaTBoxIcon';

/**
 * author: GreenTurtwig
 * id 3FDF524A-6293-4401-BEDE-7768370743CE
 * name alpha-t-box
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-t-box.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetTBoxIcon = AlphaTBoxIcon;
export default AlphabetTBoxIcon